/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Yes
 * 
 * 1 = No
 * 
 * 2 = Unknown
 */
export enum ManufacturerSpec {
  Yes = 0,
  No = 1,
  Unknown = 2
}
